import { Button } from "@shared/ui";
import { ListChecks, Lock } from "lucide-react";
import LogoLockup from "../components/LogoLockup";
import StepBody from "../components/StepBody";
import StepFooter from "../components/StepFooter";
import StepHeading from "../components/StepHeading";
import { genericClientLogoUrl } from "../lib/constants";

// External dependencies
import { useEffect } from "react";

const ValueProp = ({ icon: ValueIcon, title, body }) => (
  <li className="flex gap-3">
    <span className="flex size-9 shrink-0 items-center justify-center rounded border border-subtle bg-surface-muted">
      <ValueIcon aria-hidden className="size-[18px]" strokeWidth={1.75} />
    </span>
    <div className="flex flex-col gap-1">
      <h2 className="text-body-lg font-medium text-ink">{title}</h2>
      <p className="text-body-lg text-ink-secondary text-pretty">
        {body}
      </p>
    </div>
  </li>
);

const Consent = ({ step, nextStep, client, posthog, isUserAuthenticated }) => {
  // Effect for PostHog tracking
  useEffect(() => {
    posthog.capture("$pageview", { step });
  }, [posthog]);

  return (
    <>
      <StepBody className="pt-0">
        <div className="mb-4 flex justify-center">
          <LogoLockup
            size="lg"
            logoUrl={client.logoUrl ?? genericClientLogoUrl}
            label={client.displayName}
          />
        </div>
        <StepHeading
          title={
            <span className="font-normal">
              <strong className="font-semibold">{client.displayName}</strong>{" "}
              uses <strong className="font-semibold">Axle</strong> to securely
              share your insurance information
            </span>
          }
        />
        <ul className="flex flex-col gap-6" aria-label="Consent steps">
          <ValueProp
            icon={Lock}
            title="Secure"
            body="Axle employs bank-level encryption to secure your data end-to-end"
          />
          <ValueProp
            icon={ListChecks}
            title="Transparent"
            body="You'll see exactly what information will be shared with the application"
          />
        </ul>
      </StepBody>
      <StepFooter>
        <p className="pb-2 text-center text-small  text-ink-secondary">
          By clicking "Continue", you agree to Axle's{" "}
          <a
            target="_blank"
            href="https://www.axle.insure/legal/end-user-terms"
            className="font-medium text-ink underline underline-offset-2"
          >
            End User Terms
          </a>{" "}
          and{" "}
          <a
            target="_blank"
            href="https://www.axle.insure/legal/privacy-policy"
            className="font-medium text-ink underline underline-offset-2"
          >
            Privacy Policy
          </a>
        </p>
        <Button
          onClick={() => {
            posthog.capture("consent_axle_passport_continue");
            isUserAuthenticated
              ? nextStep("welcome-back")
              : nextStep("permissions");
          }}
        >
          Continue
        </Button>
        {isUserAuthenticated === false && (
          <Button
            variant="secondary"
            type="button"
            onClick={() => {
              posthog.capture("consent_axle_passport_sign_in");
              nextStep("axle-account-sign-in");
            }}
          >
            Sign in to access your saved accounts
          </Button>
        )}
      </StepFooter>
    </>
  );
};

export default Consent;
